import type { BuildingSocietySavingsOverviewCountryConfig } from '../../BuildingSocietySavingsOverviewConfig';

export const savingsOverview: BuildingSocietySavingsOverviewCountryConfig = {
    showCollapsibleDetails: true,
    highlights: {
        displayCreditInterestRate: true,
        displayDetailedBalanceHighlights: true,
    },
    list: {
        displayContractHolders: true,
        displayAccountNumberAndBankCode: true,
        displayExpiryDate: true,
        displayCreditInterestRate: true,
    },
    collapsibleList: {
        displayAgreedMonthlySavings: true,
        displaySigningDate: true,
        displayLoanEntitlementDate: true,
        displayTargetAmount: true,
        displayStatementDistribution: true,
        displayStateSupportStatementAgreed: true,
        displayStateSupportBonusAgreed: true,
    },
};
